import { GrossAndNet, Period } from '~/common/model'

export interface Balance {
  subscriptionId: string
  msisdn: string
  amount: GrossAndNet
}

export enum Origin {
  TPV = 'TPV',
  ATM = 'ATM',
  CALL_CENTER = 'CALL_CENTER',
  ONLINE_CHANNEL = 'ONLINE_CHANNEL',
  IVR = 'IVR',
  SCRATCH_CARD = 'SCRATCH_CARD',
  AUTOMATIC = 'AUTOMATIC',
}

export enum Type {
  RECHARGE = 'RECHARGE',
  INITIAL_RECHARGE = 'INITIAL_RECHARGE',
  CANCELLED_RECHARGE = 'CANCELLED_RECHARGE',
}

export interface Recharge {
  id: string
  origin: Origin
  type: Type
  date: string
  amount: number
}

export interface Recharges {
  subscriptionId: string
  msisdn: string
  periodDate: Period
  recharges: Recharge[]
}
